export default ['+38 099 391 4777', '+38 067 391 4777'];